import { type Filter, FilterId, isMultiFilter } from '../../types/filters';

/**
 * The dimensions a user combines with AND / OR / NOT: the entity ones, whose
 * values are catalog ids. Gender and ethnicity are weights rather than
 * categories, so `filters_v2` carries them beside the expression.
 */
const EXPRESSION_DIMENSIONS: ReadonlySet<FilterId> = new Set([
  FilterId.COMPANY,
  FilterId.INDUSTRY,
  FilterId.GEOGRAPHY,
  FilterId.ROLE,
  FilterId.CUSTOM_SKILL,
  FilterId.ACTIVITY,
]);

export const isExpressionDimension = (filterId: FilterId): boolean =>
  EXPRESSION_DIMENSIONS.has(filterId);

const dimensionOf = (filter: Filter): FilterId =>
  isMultiFilter(filter) ? filter.wrappedFilterId : filter.id;

/**
 * Whether a filter combines as on Talent Discovery: one of the entity
 * dimensions, other than the page's own entities.
 */
export const isExpressionFilter = (filter: Filter): boolean =>
  !filter.isPrimary && isExpressionDimension(dimensionOf(filter));
